import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/content';
export function Problem() {
  return <section className="bg-paper py-20 sm:py-24" aria-labelledby="problem-title" style={{
    paddingTop: "18px"
  }} data-id="element-168" data-mp="2pe7e21oazh48">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-169" data-mp="2bf7o8qp20w6h">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-170" data-mp="2geatoc8y54ez">El costo de preparar todo desde cero</p>
        <h2 id="problem-title" className="mt-4 text-balance text-center font-display text-[2rem] leading-[1.1] text-petrol sm:text-5xl" data-id="element-171" data-mp="21od35pnjo2mm">
          Tu tiempo debería estar en la sesión, <em className="text-terra" data-id="element-172" data-mp="1sq15j3o9g4ko">no buscando durante horas</em> qué preguntar después.
        </h2>

        <ul className="mt-12 space-y-3" data-id="element-173" data-mp="1wrv1iynigkei">
          {problems.map(p => <li key={p} className="flex items-start gap-4 rounded-xl bg-cream/70 px-5 py-5 text-lg text-ink-soft sm:px-6" data-id="element-174" data-mp="1ir22q1q6f35l">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-terra-wash text-terra-deep" data-id="element-175" data-mp="1nqepkmh1sa86">
                <XIcon className="h-4 w-4" strokeWidth={2.6} aria-hidden="true" data-id="element-176" data-mp="t8dntkbjo536" />
              </span>
              {p}
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-177" data-mp="12ad3o9atp34j">
          <p className="text-balance font-display text-2xl leading-snug text-petrol sm:text-3xl" style={{
          fontSize: "28px",
          fontWeight: "500",
          borderTopWidth: "0px",
          borderRightWidth: "0px",
          borderBottomWidth: "0px",
          borderLeftWidth: "0px",
          borderColor: "#8DCEFC"
        }} data-id="element-178" data-mp="12a3cwjhyerxs">
            Preparar una buena sesión requiere criterio profesional.
          </p>
          <p className="mt-3 text-lg text-ink-mute" data-id="element-179" data-mp="jbhcl6u9h4ux">
            Eso no significa que cada vez tengas que empezar desde una página vacía.
          </p>
        </div>
      </div>
    </section>;
}